export class ModuleEntry {

  public name: string;

  public type: any;
}
